// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { logoStyles } from "@stoneage/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: 174px;
        height: 34px;

        ${xScreen("lte", "md")} {
            max-width: 144px;
            height: 28px;
        }
        & .home-page-link {
            width: 100%;
            height: 100%;
        }

        ${TypographyStyle} {
            line-height: 0;
        }
    `,
};

logoStyles.img = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    `,
};
